// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom"; // ✅ for navigation
// import "./Courses.css";
// import RegisterButton from "../RegisterProtect/RegisterButton";

// export default function Courses({ showHeading = true }) {
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Fetch courses from API
//   useEffect(() => {
//     const fetchCourses = async () => {
//       try {
//         const response = await fetch("https://agepcoatings.com/getcourses");
//         const data = await response.json();
//         setCourses(data);
//       } catch (error) {
//         console.error("Error fetching courses:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchCourses();
//   }, []);

//   if (loading) {
//     return <p className="text-center my-5">Loading courses...</p>;
//   }

//   return (
//     <section className="container course-wrapper py-5 mb-5">
//       {showHeading && <h3 className="fw-bold mt-4">Courses</h3>}
//       <div className="row g-4 justify-content-center">
//         {courses.map((course) => {
//           return (
//             <div
//               className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 d-flex justify-content-center"
//               key={course._id}
//             >
//               <div className="course-card">
//                 <div className="position-relative">
//                   <img
//                     src={course.image} // fallback image
//                     alt={course.badge}
//                     className="course-img"
//                   />
//                   {/* <span className="badge bg-light text-dark border course-code position-absolute top-0 start-0 m-3">
//                     {course.badge || "N/A"}
//                   </span> */}
//                 </div>

//                 <div className="course-card-body">
//                   <div className="d-flex align-items-center mb-2 small flex-wrap">
//                     <span className="me-3">
//                       <i className="bi bi-bar-chart me-1"></i>
//                       {course.levels || "0 Levels"}
//                     </span>
//                     {/* <span>
//                       <i className="bi bi-people-fill me-1"></i>
//                       {course.enrolledUsers} Enrolled
//                     </span> */}
//                     <span className="d-flex align-items-center mx-3">
//                       <i className="bi bi-star-fill text-warning"></i>
//                       <span className="fw-bold">{course.rating || "0.0"}</span>
//                       <span className="text-muted small"></span>
//                     </span>
//                   </div>

//                   {/* <div className="d-flex align-items-center mb-2 small text-muted">
//                     <i className="bi bi-check2-circle me-1"></i> Check Schedule
//                   </div> */}

//                   <h6 className="fw-bold courses-title">{course.courseName}</h6>

//                   <p className="text-muted course-description">
//                     {course.courseDescription}
//                   </p>

//                   <p className="small fw-bold mb-3 text-muted">
//                     Secure Your Spot Now!
//                   </p>
//                   <div className="d-flex justify-content-between">
//                     {/* ✅ Navigate to Course Details */}
//                     <Link to={`/courses/${course.courseId}`}>
//                       <button className="course-details rounded-5">
//                         Course Details
//                       </button>
//                     </Link>

//                     <RegisterButton className="course-btn btn-sm" />

                  
//                   </div>
//                     {/* <PaymentButton
//                       courseId={course.courseId}
//                       courseTitle={course.courseName}
//                       amount={course.price || 1}
//                     /> */}
//                 </div>
//               </div>
//             </div>
//           );
//         })}
//       </div>
//     </section>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Courses.css";
import RegisterButton from "../RegisterProtect/RegisterButton";

export default function Courses({ showHeading = true }) {
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ===================== FETCH COURSES (UI ONLY) ===================== */
  useEffect(() => {
    fetch("https://agepcoatings.com/getcourses")
      .then((res) => res.json())
      .then((data) => setCourses(Array.isArray(data) ? data : []))
      .finally(() => setLoading(false));
  }, []);

  /* ===================== FETCH SCHEDULES (LOGIC SOURCE) ===================== */
  useEffect(() => {
    fetch("https://agepcoatings.com/eacschedule")
      .then((res) => res.json())
      .then((data) => {
        if (data.success && Array.isArray(data.schedules)) {
          setSchedules(data.schedules);
        } else {
          setSchedules([]);
        }
      })
      .catch(() => setSchedules([]));
  }, []);

  /* ===================== HELPERS ===================== */
  const normalizeCourse = (str = "") =>
    String(str)
      .toLowerCase()
      .replace(/\(.*?\)/g, "")
      .replace(/program|certification/g, "")
      .replace(/[^a-z]/g, "");

  const getLevelNumber = (val) => {
    const m = String(val).match(/\d+/);
    return m ? Number(m[0]) : null;
  };

  const isFuture = (s) =>
    s.startDate &&
    !isNaN(new Date(s.startDate)) &&
    new Date(s.startDate) > new Date();

  /* ===================== BUILD AVAILABILITY FROM SCHEDULES ONLY ===================== */
  const scheduleMap = useMemo(() => {
    const map = {};

    schedules.forEach((s) => {
      if (!s.courseName || !isFuture(s)) return;

      const key = normalizeCourse(s.courseName);
      const date = new Date(s.startDate);

      if (!map[key]) {
        map[key] = {
          nextDate: date,
          nextLevel: getLevelNumber(s.levelName),
        };
      } else if (date < map[key].nextDate) {
        map[key].nextDate = date;
        map[key].nextLevel = getLevelNumber(s.levelName);
      }
    });

    return map;
  }, [schedules]);

  /* ===================== LOADING ===================== */
  if (loading) {
    return <p className="text-center my-5">Loading courses...</p>;
  }

  /* ===================== RENDER ===================== */
  return (
    <section className="container course-wrapper py-5 mb-md-5">
      {showHeading && <h3 className="fw-bold mt-4 mb-4">Courses</h3>}

      <div className="row g-4 justify-content-center">
        {courses.map((course) => {
          const key = normalizeCourse(course.courseName);
          const scheduleInfo = scheduleMap[key];
          const hasFuture = !!scheduleInfo;

          return (
            <div
              key={course._id}
              className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center"
            >
              <div className="course-card">
                <img
                  src={course.image}
                  alt={course.courseName}
                  className="course-img"
                />

                <div className="course-card-body">
                  <div className="d-flex align-items-center mb-2 flex-wrap">
                    <span className="me-3">
                      <i className="bi bi-book me-1"></i>
                      {course.levels} Levels
                    </span>

                    <span className="mx-3">
                      <i className="bi bi-star-fill text-warning"></i>{" "}
                      {course.rating || "0.0"}
                    </span>

                    {/* ===== CHECK / COMING SOON (SCHEDULE-DRIVEN) ===== */}
                    <div className="d-flex align-items-center text-muted">
                      <i
                        className={`bi ${
                          hasFuture ? "bi-calendar2" : "bi-clock"
                        } me-1`}
                        style={{ color: "#111D2D", fontSize: "14px" }}
                      ></i>

                      {hasFuture ? (
                        <span
                          style={{
                            cursor: "pointer",
                            color: "#111D2D",
                            fontSize: "14px",
                          }}
                          onClick={() =>
                            navigate(
                              `/shadeule?course=${encodeURIComponent(
                                course.courseName
                              )}&level=${encodeURIComponent(
                                scheduleInfo.nextLevel
                              )}`
                            )
                          }
                        >
                          Check Schedule
                        </span>
                      ) : (
                        <span
                          style={{
                            color: "#111D2D",
                            fontSize: "14px",
                          }}
                        >
                          Coming Soon
                        </span>
                      )}
                    </div>
                  </div>

                  <h6 className="fw-bold">{course.courseName}</h6>
                  <p className="text-muted">{course.courseDescription}</p>

                  <div className="d-flex justify-content-between">
                    <Link to={`/courses/${course.courseId}`}>
                      <button className="course-details rounded-5">
                        Course Details
                      </button>
                    </Link>

                    <RegisterButton className="course-btn btn-sm" />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
